/* eslint-disable */
import React, {useCallback, useEffect, useRef, useState} from "react";
import {getExtraFields, storeExtraFields} from "@/apis/register/extraFields";
import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import {makeRequired, makeValidate} from "mui-rff";
import {schema} from "@/features/user/extraFields/validations";
import {makeYupTranslatedError} from "@/helpers/yup";
import ExtraFieldsForm from "@/features/user/extraFields/components/form";
import {checkErrorResponse} from "@/helpers/axios";
import {toastError, toastSuccess} from "@/helpers/toast";
import {setBackdrop} from "@/store/slices/appSlice";
import lGet from "lodash/get";
import {convertJSONToString, errorMessageFromServer} from "@/utils/server";

const ExtraFields = ({isModal, closePopover, from = "Route"}: any): any => {
    // know extra fields count
    const countExtraFields: number = 20;

    // loader
    const [loading, setLoading] = useState(true);

    // to know if modal is open
    const [modalOpen, setModalOpen] = useState(false);

    // to know if modal is submitting data
    const [submitting, setSubmitting] = useState(false);

    const fields: Record<string, unknown> = {};

    for (let i = 1; i <= countExtraFields; i++) {
        const key = `campo${i}`;
        fields[key] = ''; // or assign an initial value
    }

    // campos extras son 20
    const initialValues: any = fields;

    // hack to override values when component mounts
    const initialValuesRef = useRef<any>(initialValues);

    // validations
    const currentSchema = schema(countExtraFields);
    const validateForm = makeValidate(currentSchema, makeYupTranslatedError);
    const required = makeRequired(currentSchema);

    // data to load
    const getData = useCallback(async () => {
        // set loader
        setLoading(true);

        try {
            const extraFieldsRequest = await getExtraFields();

            const userExtraFields = extraFieldsRequest.data.extra_fields;

            //console.log('userExtraFields', userExtraFields);

            initialValuesRef.current = {
                ...initialValuesRef.current,
                ...userExtraFields
            }

        } catch (e) {
            //console.error('error', e);
            checkErrorResponse(e);
        } finally {
            // set loader
            setLoading(false);
        }
    }, []);

    const history = useHistory();
    const dispatch = useDispatch();
    const submitData = useCallback(async (payload: any) => {
        setSubmitting(true);

        try {
            // clear nulls in payload
            for (const prop in payload) {
                if (payload[prop] === null) {
                    payload[prop] = "";
                }
            }

            // call save endpoint
            const response = await storeExtraFields(payload);

            // toast with backdrop and reload
            toastSuccess(response.data.message, {
                onOpen: () => (isModal) && dispatch(setBackdrop(true)),
                onClose: () => (isModal) && history.go(0),
                autoClose: 2000,
            });

            return true;
        } catch (error) {
            if (lGet(error, 'data')) {
                const errors = error.data.errors;
                const message = errorMessageFromServer(convertJSONToString(errors));
                toastError(message);
            } else {
                console.error('error: ', error);
                checkErrorResponse(error);
            }
            return false;
        } finally {
            setSubmitting(false);
        }
    }, []);

    const onSubmit = async (values: any) => {
        return submitData(values).catch((e) => console.error(e));
    };

    useEffect(() => {
        if (!isModal)
            getData().finally(() => null);
    }, []);

    useEffect(() => {
        //console.log("@StepOne sensing value modalOpen: ", modalOpen);
        if (modalOpen) {
            //console.log("@StepOne modal is open and not loaded data first time");
            getData().finally(() => null);
        }
    }, [modalOpen])

    const formProps: any = {
        countExtraFields,
        validateForm,
        required,
        onSubmit,
        initialValues: initialValuesRef.current,
        submitting,
        isModal,
        closePopover,
        setModalOpen,
        loading
    };

    return (
        <>
            {<ExtraFieldsForm {...formProps}/>}
        </>
    );
}

export default ExtraFields;